// extracted by mini-css-extract-plugin
module.exports = {"up":"RankChange_up__GCVBH","down":"RankChange_down__2eeXL","increment":"RankChange_increment__1JZzu"};